import { Box, Typography } from "@mui/material";
import { LoginForm } from "@/templates/Login";
import useLoginPage from "./useLoginPage";

import { alpha } from "@mui/material/styles";
import logo from "@/assets/logo/main-logo.svg";

/**
 * 로그인 페이지
 *
 * @returns {JSX.Element}
 */
export const Login = () => {
  const { isLoading, error, errorMessage, handleLogin } = useLoginPage();

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: {
          xs: "column",
          md: "row",
        },
        height: "100%",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
        }}
      >
        <Typography variant="body1" color="secondary">
          <img src={logo} alt="logo" />
        </Typography>
      </Box>
      <Box
        sx={(theme) => ({
          display: "flex",
          flex: 1,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom center",
          backgroundSize: {
            xs: "120%",
            md: "150%",
          },
          backgroundColor: alpha(theme.palette.primary.main, 0.8),
          alignItems: {
            xs: "start",
            md: "center",
          },
          px: 4,
          flexDirection: "row",
          alignContent: "center",
          justifyContent: "center",
        })}
      >
        <Box
          sx={{
            width: "100%",
            margin: "auto", // 추가: 수평 중앙 정렬
            textAlign: "center",
          }}
        >
          <Typography variant="body1" color="secondary">
            STEP AI Super Admin 페이지
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          p: 4,
        }}
      >
        <LoginForm
          isLoading={isLoading}
          error={error}
          errorMessage={errorMessage}
          onSubmit={(data) => {
            handleLogin(data);
          }}
        />
      </Box>
    </Box>
  );
};
